export default __webpack_public_path__ + "static/char-32-504d4282be70913458c184080c67e16c.gif";